/*
*   createBoard 可读端
* */

import {createApi} from "./repository/api";
import {createPaint} from "./repository/paint";
import {createWebsocket} from "./repository/websocket";
import {KEY_CHANGE_PAGE, R_MODE_LISTEN, R_MODE_PAGE, R_MODE_TIME} from "./constant";
import {getTimestamp} from "./util/service";

function createRBoard (options) {
    const {dom, token, id, apiDomain = 'https://service.myun.tv', initPage = 1, mode, wsUrl = 'wss://msg-ws.myun.tv'} = options;
    const ws = options.ws || createWebsocket(wsUrl, id);
    const paint = createPaint({dom});
    const api = createApi(apiDomain, token);
    // const eightHoursTimestamp = 8 * 60 * 60 * 1000;// 后端记录的options的timestamp忘记加时区了  而这个api用了一段时间了  只能将错就错 ps 2020/6/16 后端把时区都添上了  我不知道

    let currentPage = initPage;
    let boardData = null;
    let delay = 0;

    paint.setDisable(true);
    if (mode === R_MODE_PAGE) {  setCurrentPage(currentPage); }
    
    return getExportFnByMode(mode);

    function getExportFnByMode (mode) {
        const obj = {
            listen: () => errorFunction('listen not found'),
            setDelay: () => errorFunction('setDelay not found'),
            setCurrentPage: () => errorFunction('setCurrentPage not found'),
            getCurrentPage: () => errorFunction('getCurrentPage not found'),
            setNowTime: () => errorFunction('setNowTime not found'),
            destroy,
            resize
        };
        if (mode === R_MODE_PAGE) {
            obj.setCurrentPage = setCurrentPage;
            obj.getCurrentPage = getCurrentPage;
        }
        if (mode === R_MODE_TIME) {
            obj.setNowTime = setNowTime;
        }
        if (mode === R_MODE_LISTEN) {
            obj.listen = listen;
            obj.setDelay = setDelay;
        }

        return obj;
    }

    function resize() {
        paint && paint.render();
    }

    function errorFunction(message) {
        throw new Error(message)
    }

    function listen() {
        api.getBoardData(id, res => {
            if (!res.options ) { res.options = [] }
            boardData = res.options.map(option => {
                if (typeof option.data == 'string') { option.data = JSON.parse(option.data) }
                option.timestamp = getTimestamp(option)
                return option;
            });
            const newestOptions = boardData.filter(option => option.page === currentPage);
            newestOptions.forEach(option => {
                if (option.data.key !== KEY_CHANGE_PAGE) { paint.addUndoHistory(option.data); }
            });
            paint.render();
            _subscribe();
        });
    }

    // 主要用于setNowTime，不涉及render
    function _updateData() {
        ws.unsubscribe();
        ws.subscribe(msg => {
            if (!msg) return;
            if (msg instanceof Array) { // 因为createWSOfUpdate中update的存在, 可能msg会是完整的BoardData， 需要去重
                const newBoardData = msg.map(option => {
                    if (typeof option.data == 'string') { option.data = JSON.parse(option.data) }
                    option.timestamp = getTimestamp(option)
                    return option;
                });
                boardData = Object.assign(boardData, newBoardData);
            } else {
                let currentData = msg;
                if (typeof currentData === 'string') { currentData = JSON.parse(msg) }
                if (typeof currentData.data === 'string') { currentData.data = JSON.parse(currentData.data)}
                currentData.timestamp = getTimestamp(currentData)
                boardData.push({data: currentData.data, page: currentData.page, timestamp: currentData.timestamp});
            }
        });
    }

    function _subscribe() {
        ws.unsubscribe();
        ws.subscribe(msg => {
            if (!msg) return;
            if (msg instanceof Array) { // 因为createWSOfUpdate中update的存在, 可能msg会是完整的BoardData， 需要去重
                const newBoardData = msg.map(option => {
                    if (typeof option.data == 'string') { option.data = JSON.parse(option.data) }
                    option.timestamp = getTimestamp(option)
                    return option;
                });
                boardData = Object.assign(boardData, newBoardData);
            } else {
                let tempData = msg;
                if (typeof tempData === 'string') { tempData = JSON.parse(msg) }
                if (typeof tempData.data === 'string') { tempData.data = JSON.parse(tempData.data)}
                tempData.timestamp = getTimestamp(tempData)
                boardData.push({data: tempData.data, page: tempData.page, timestamp: tempData.timestamp});
            }

            setTimeout(() => {
                /*得到当前数据最新页*/
                boardData.forEach(option => {
                    if (option.data.key === KEY_CHANGE_PAGE) { currentPage = option.data.data[1] }
                });
                const newestOptions = boardData.filter(option => option.page === currentPage);
                paint.clearOptions();
                newestOptions.forEach(option => {
                    if (option.data.key !== KEY_CHANGE_PAGE) { paint.addUndoHistory(option.data); }
                });
                paint.render();
            }, delay)
        });
    }

    function setDelay(time) {
        delay = time;
    }
    
    function setCurrentPage(page) {
        currentPage = page;
        if (boardData) {
            _getOptionsByPage(currentPage);
        } else {
            api.getBoardData(id, res => {
                if (!res.options ) { res.options = [] }
                boardData = res.options.map(option => {
                    if (typeof option.data == 'string') { option.data = JSON.parse(option.data) }
                    option.timestamp = getTimestamp(option)
                    return option;
                });
                _getOptionsByPage(currentPage);
            })
        }
    }
    
    function getCurrentPage() {
        return currentPage;
    }
    
    function setNowTime(nowTime) {
        if (boardData) {
            _updateByTime(nowTime);
        } else {
            api.getBoardData(id, res => {
                if (!res.options ) { res.options = [] }
                boardData = res.options.map(option => {
                    if (typeof option.data == 'string') { option.data = JSON.parse(option.data) }
                    option.timestamp = getTimestamp(option)
                    return option;
                });
                _updateByTime(nowTime);
            });
            _updateData();
        }
    }

    function _getOptionsByPage(page) {
        const currentPageOptions = boardData.filter(option => option.page === page);
        paint.clearOptions();
        currentPageOptions.forEach(item => {
            if (item.data.key !== KEY_CHANGE_PAGE) { paint.addUndoHistory(item.data); }
        });
        paint.render();
    }

    function _updateByTime(nowTime) {
        if (!boardData) return;
        boardData.forEach(option => {
            if (option.timestamp <= parseInt(nowTime) && option.data.key === KEY_CHANGE_PAGE) {
                currentPage = option.data.data[1];
            }
        });
        const currentPageOptions = boardData.filter(option => option.page === currentPage);

        paint.clearOptions();
        currentPageOptions.forEach(item => {
            if (item.timestamp <= parseInt(nowTime) && item.data.key !== KEY_CHANGE_PAGE) {
                paint.addUndoHistory(item.data);
            }
        });
        paint.render();
    }

    function destroy() {
        paint && paint.destroy();
        ws.unsubscribe();
        ws.close();
    }
}

export {
    createRBoard
}
